import React, { Component } from 'react';
import './css/welcome.css';

class Welcome extends Component {
	constructor(props){
		super(props);
		//console.log("Welcome()");
		this.state = {scheduledState: ""};
	}
	componentDidMount() {
		//console.log("Welcome: componentDidMount()");
	}

	componentWillUnmount() {
	}
	
	scheduledOutage(){
		//console.log("Welcome.scheduledOutage()");
		var s = window.l10n[window.locale]["welcome.message"].trim().split("#");
		var title = s[0] || "";
		var message = s[1] || "";
		
		document.getElementById("id-welcome-scheduled-title").innerHTML = title;
		document.getElementById("id-welcome-scheduled-message").innerHTML = message;
		this.setState({scheduledState: "scheduled"});
	}
	
	render() {
		return (
			<div id="welcomepage" className={"welcome-container " + this.state.scheduledState}>
				<div className="welcome-r1">
					{ window.l10n[window.locale]["landing.yourlease"] }
				</div>
				<div className="welcome-r2">
					{ window.l10n[window.locale]["landing.documentcentre"] }
				</div>
				<div className="welcome-r3"/>
				<div id="id-welcome-scheduled" className="welcome-scheduled">
					<div id="id-welcome-scheduled-title"/>
					<div id="id-welcome-scheduled-message"/>					
				</div>				
			</div>
		);
	}
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/welcome.js